import React from "react";
import "./EmissionToggle.scss";

interface IProps {
    value: boolean;
    onChange: (newValue: boolean) => void;
}

export function EmissionToggle(props: IProps) {
    const { value, onChange } = props;
    return (
        <div className={`emission-toggle-wrapper ${value ? 'is-true' : 'is-false'}`} onClick={() => {
            onChange(!value);
        }}>
            <h1>Emission state</h1>
            <div className="ball-wrapper">
                <div className="ball" />
            </div>
            <div className="labels">
                <input type="radio" id={'emission-true'} checked={value} onChange={() => {
                    // void fn
                }}/>
                <label htmlFor={'emission-true'}>As it is</label>
                <input type="radio" id={'emission-false'} checked={!value} onChange={() => {
                    // void fn
                }}/>
                <label htmlFor={'emission-false'}>Improved</label>
            </div>
        </div>
    )
}
